import { createContext } from "react";

import type { VoiceCallContextValue } from "./VoiceCallContextValue";

export const VoiceCallContext = createContext<VoiceCallContextValue | null>(null);

VoiceCallContext.displayName = "VoiceCallContext";
